import React, { lazy } from "react";
import { Switch, Route, useLocation } from "react-router-dom";
import * as Routes from "./index";
import authService from "../utils/authService";
import AuthenticatedRoute from "./authenticatedRoute";
import LoginRoute from "./loginRoute";
import routes from "../utils/routes";


const PageNotFound = lazy(() => import("../core/components/Error/PageNotFound"));
const NoPageAccess = lazy(() => import("../core/components/Error/NoPageAccess"));
const Login = lazy(() => import("../modules/auth/containers/Login"));
const Profile = lazy(() => import("../modules/auth/containers/Profile"));
const HopContainer = lazy(() => import("../core/modules/hop/HopContainer"));

const ServiceRequestDashBoard = lazy(() => import("../modules/serviceRequest/containers/Servicerequest"));
const ServiceRequestView = lazy(() => import("../modules/serviceRequest/containers/ServiceRequestView"));
const CustomerView = lazy(() => import("../modules/serviceRequest/containers/CustomerView"));
const CreateServiceRequest = lazy(() => import("../modules/serviceRequest/containers/CreateServiceRequest"));

const PrivateRoutes = (props) => {
  const { routes: privateRoutes } = props;
  let homeRoute = null;
  const location = useLocation();
  return (
    <>
      <Switch>
        <LoginRoute exact path={routes.LOGIN} component={Login} />

        <AuthenticatedRoute exact path="/" component={ServiceRequestDashBoard}></AuthenticatedRoute>
        <AuthenticatedRoute exact path={routes.SERVICE_REQUEST} component={ServiceRequestDashBoard}></AuthenticatedRoute>
        <AuthenticatedRoute exact path={routes.SERVICE_REQUEST_DETAILS} component={ServiceRequestView}></AuthenticatedRoute>
        <AuthenticatedRoute exact path={routes.SERVICE_REQUEST_CUSTOMER_DETAILS} component={CustomerView}></AuthenticatedRoute>
        <AuthenticatedRoute exact path={routes.CREATE_SERVICE_REQUEST} component={CreateServiceRequest}></AuthenticatedRoute>

        {privateRoutes.map((route) => {
          if (route.homeUrl) {
            homeRoute = route;
          }
          return <AuthenticatedRoute exact component={Routes[route.component]} key={route.url} path={route.url} activeMenu={route.activeMenu} routeKey={route.routeKey} />;
        })}
        {homeRoute ? <AuthenticatedRoute exact path="/" component={Routes[homeRoute.component]} activeMenu={homeRoute.activeMenu} routeKey={homeRoute.routeKey} /> : null}
        {!authService.isAuthenticated() ? <LoginRoute exact path="/" component={Login} /> : null}
        {Object.values(routes).includes(location.pathname) ? <Route component={NoPageAccess} /> : <Route component={PageNotFound} />}
      </Switch>
    </>
  );
};

export default PrivateRoutes;
